import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomLoginComponent } from './custom-login/custom-login.component';
import { RouterModule } from '@angular/router';
import { UrlModule, I18nModule, provideDefaultConfig, CmsConfig } from '@spartacus/core';
import { FormErrorsModule, PageSlotModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomUpdatePasswordComponent } from './custom-update-password/custom-update-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomLoginFormModule } from './custom-login-form/custom-login-form.module';
import { CustomForgotPasswordComponent } from './custom-forgot-password/custom-forgot-password.component';
import { CustomResetPasswordComponent } from './custom-reset-password/custom-reset-password.component';
import { MfaAuthenticationComponent } from './mfa-authentication/mfa-authentication.component';
import { CustomInventoryLoginComponent } from './custom-inventory-login/custom-inventory-login.component';
import { CustomInventoryUpdatePasswordComponent } from './custom-inventory-update-password/custom-inventory-update-password.component';
import { CustomPlatformBannerComponent } from './custom-platform-banner/custom-platform-banner.component';
import { CountrieslistComponent } from './custom-login-form/custom-login-form/countrieslist/countrieslist.component';
import { CustomASMLoginComponent } from './custom-asmlogin/custom-asmlogin.component';

@NgModule({
    imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, SharedModule, ReactiveFormsModule,
        FormsModule, CustomLoginFormModule, FormErrorsModule, CustomLoginComponent, CustomResetPasswordComponent, CustomUpdatePasswordComponent,
        MfaAuthenticationComponent, CustomForgotPasswordComponent, CustomInventoryLoginComponent,
        CustomInventoryUpdatePasswordComponent, CustomPlatformBannerComponent, CountrieslistComponent, CustomASMLoginComponent],
    providers: [
        // tslint:disable-next-line:no-angle-bracket-type-assertion
        provideDefaultConfig(<CmsConfig>{
            cmsComponents: {
                LoginComponent: {
                    component: CustomLoginComponent,
                },
            },
        }),
    ],
    exports: [CustomLoginComponent], schemas: [NO_ERRORS_SCHEMA]
})
export class CustomLoginModule { }
